module.exports = __webpack_public_path__ + "static/media/financeContent.1e76f8a1.png";